import { Dialog } from '@eppendorf/vnls-react-components';
import { User } from '@eppendorf/vnls-user-tenant-utils';
import { FunctionComponentElement, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { useAutoFocus } from '$shared/custom-hooks/useAutoFocus';

import { useContactSupport } from '$components/chat-bot/useContactSupport';
import {
  ConfirmDialogIconType,
  ConfirmationDialog,
} from '$components/confirmation-dialog/confirmation-dialog';
import { displayUser } from '$features/invite-user/invite-user-dialog/screens/display-user.util';

export interface DeleteErrorProps {
  user: User;
}

export function DeleteErrorScreen({
  user,
}: DeleteErrorProps): FunctionComponentElement<void> {
  const { t } = useTranslation();
  const handleContactSupport = useContactSupport();
  const closeButtonRef = useRef<null | HTMLButtonElement>(null);

  useAutoFocus(closeButtonRef);
  return (
    <ConfirmationDialog
      title={t('userDelete.deleteError')}
      iconType={ConfirmDialogIconType.error}
      dialogDescription={
        <>
          <Trans
            i18nKey="userDelete.descriptionUserNotDeleted"
            values={{
              user: displayUser(user),
            }}
            components={{ bold: <span className="font-weight-bold" /> }}
          />{' '}
          <p className="m-top-xl">
            <span>{t('errors.contactSupport')} </span>
            <Dialog.Close>
              <button
                type="button"
                onClick={handleContactSupport}
                className="btn-as-link font-weight-regular color-blue-500"
              >
                {t('errors.contactSupport2')}
              </button>
            </Dialog.Close>
          </p>
        </>
      }
    />
  );
}
